import { Injectable } from '@angular/core';

import { HttpClient, HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import { IProjeto } from './../models/projeto.model';
import { ApplicationConfigService } from '../config/application-config.service';
import { DATE_FORMAT } from '../util/input.constants';


export type EntityResponseType = HttpResponse<IProjeto>;

export type EntityArrayResponseType = HttpResponse<IProjeto[]>;

@Injectable({ providedIn: 'root' })

export class ProjetoService {

  protected resourceUrl = this.applicationConfigService.getEndpointFor('api/projeto');

  constructor(protected http: HttpClient, protected applicationConfigService: ApplicationConfigService) {}

  create(projeto: IProjeto): Observable<EntityResponseType> {
    return this.http.post<IProjeto>(this.resourceUrl, projeto, { observe: 'response' });
  }

  update(projeto: IProjeto): Observable<EntityResponseType> {
    return this.http.put<IProjeto>(`${this.resourceUrl}`, projeto, { observe: 'response' });
  }

  findById(id: number): Observable<EntityResponseType> {
    return this.http.get<IProjeto>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  findAll(): Observable<EntityArrayResponseType> {
    return this.http.get<IProjeto[]>(this.resourceUrl, { observe: 'response' });
  }

  findAllByUserId(id: number): Observable<EntityArrayResponseType> {
    return this.http.get<IProjeto[]>(`${this.resourceUrl}-by-user/${id}`, { observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.http.delete(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  protected convertDateFromClient(Projeto: IProjeto): IProjeto {
    return Object.assign({}, Projeto, {
        dataAtualizacao: Projeto.dataAtualizacao?.isValid() ? Projeto.dataAtualizacao.format(DATE_FORMAT) : undefined,
        timestamp: Projeto.timestamp?.isValid() ? Projeto.timestamp.format(DATE_FORMAT) : undefined,
    });
  }
}
